import {z} from 'zod';

import {isTelephonyCallPairingResource, TelephonyCallPairingResource} from '@dms/shared';

/**
 * A record opened while the viewer had a call, as its detail page showed it then: enough for the
 * viewer to recognise it in the after-call card without another request.
 */
export const TelephonyCallPairableRecordSchema = z.object({
  resourceId: z.custom<TelephonyCallPairingResource>(
    (value) => typeof value === 'string' && isTelephonyCallPairingResource(value)
  ),
  recordId: z.string(),
  /** What the record is about, e.g. the vehicle; the page title when there is nothing better. */
  title: z.string(),
  /** Number, state and similar, in the order the page header shows them. */
  details: z.array(z.string()),
  /** For the customer-mismatch message. */
  customerName: z.string().nullable(),
  openedAt: z.string(),
});

export type TelephonyCallPairableRecord = z.infer<typeof TelephonyCallPairableRecordSchema>;
